import { mapState } from 'vuex';
export default {
  props: {
    dialogVisible: Boolean
  },
  data() {
    return {
      show: false
    };
  },
  watch: {
    dialogVisible(newVal) {
      this.show = newVal;
    }
  },
  computed: {
    ...mapState({
      State: state => state
    })
  },
  methods: {
    changeVal() {
      this.State.guideObjShow = false;
    }
  }
};